import { LOCAL_STORAGE_KEYS } from '../../constants/AppConstants';
import auditAssignmentModel from '../../models/auditAssignmentModel';
import submissionModel from '../../models/submissionModel';
import AuditManager from '../reactDataManager/AuditManager';
import { PBStorage } from '../../services/storageService/GlobalData';

class NotificationManager {
  //save recently missed activities notifications
  async saveMissedActivitiesNotifications(notifications) {
    try {
      notifications = notifications || [];
      await PBStorage.set(
        LOCAL_STORAGE_KEYS.MISSED_ACTIVITIES_NOTIFICATION,
        notifications,
      );
      return true;
    } catch (e) {
      console.log('saveMissedActivitiesNotificationsFailed', e);
      return false;
    }
  }

  //get recently missed activities notifications
  async getMissedActivitiesNotifications() {
    let notifications =
      (await PBStorage.get(
        LOCAL_STORAGE_KEYS.MISSED_ACTIVITIES_NOTIFICATION,
      )) || [];

    return notifications;
  }

  //clear recently missed activities notifications
  async clearMissedActivitiesNotifications() {
    await PBStorage.set(LOCAL_STORAGE_KEYS.MISSED_ACTIVITIES_NOTIFICATION, []);
  }

  async saveMobileNotifications(notifications) {
    try {
      let notificationArr =
        (await PBStorage.get(LOCAL_STORAGE_KEYS.NOTIFICATIONS)) || [];
      let notficiationToSave = [];
      let audits = [];

      for (let i in notifications) {
        if (notifications[i].submission) {
          let submission = submissionModel(notifications[i].submission);
          submission.submission_violation_history =
            notifications[i].submission.submission_violation_history;
          notifications[i].submission = submission;
        } else if (notifications[i].audit_assignment) {
          audits.push(auditAssignmentModel(notifications[i].audit_assignment));
        }
        notficiationToSave.push(notifications[i]);
      }

      AuditManager.saveAudits(audits);

      for (let i in notficiationToSave) {
        let noti = notficiationToSave[i];
        let notiIndex = notificationArr.findIndex(
          (q) => q.mobile_notification_id == noti.mobile_notification_id,
        );

        if (notiIndex != -1) {
          notificationArr[notiIndex] = noti;
        } else {
          notificationArr.push(noti);
        }
      }
      await PBStorage.set(LOCAL_STORAGE_KEYS.NOTIFICATIONS, notificationArr);
      return true;
    } catch (e) {
      console.log('saveMobileNotificationsFailed', e);
      return false;
    }
  }

  async saveMobileNotificationsUpdates(notficiationToSave) {
    try {
      let notificationArr =
        (await PBStorage.get(LOCAL_STORAGE_KEYS.NOTIFICATIONS_UPDATE)) || [];

      for (let i in notficiationToSave) {
        let noti = notficiationToSave[i];
        let notiIndex = notificationArr.findIndex(
          (q) => q.mobile_notification_id == noti.mobile_notification_id,
        );

        if (notiIndex != -1) {
          notificationArr[notiIndex] = noti;
        } else {
          notificationArr.push(noti);
        }
      }
      await PBStorage.set(
        LOCAL_STORAGE_KEYS.NOTIFICATIONS_UPDATE,
        notificationArr,
      );
      return true;
    } catch (e) {
      console.log('saveMobileNotificationsUpdatesFailed', e);
      return false;
    }
  }

  async getNotificationsUpdates() {
    let notificationArr =
      (await PBStorage.get(LOCAL_STORAGE_KEYS.NOTIFICATIONS_UPDATE)) || [];
    return notificationArr;
  }

  async getMobileNotifications() {
    let notificationArr =
      (await PBStorage.get(LOCAL_STORAGE_KEYS.NOTIFICATIONS)) || [];

    for (let i in notificationArr) {
      if (notificationArr[i].audit_assignment) {
        let audit = await AuditManager.getAuditById(
          notificationArr[i].module_id,
        );
        if (audit) notificationArr[i].audit_assignment.status = audit.status;
      }
    }
    return notificationArr;
  }
}

export default new NotificationManager();
